export function updateProfile(state, profile) {
  state.profile = profile;
}

export function updateIsAuthChecked(state, flag) {
  state.isAuthChecked = flag;
}